import Swiper from 'swiper'

const Events = () => {
  const swiper = new Swiper('.events_component', {
    slidesPerView: 'auto',
    spaceBetween: 24,
    loop: false,
    centeredSlides: true,

    breakpoints: {
      640: {
        slidesPerView: 3,
      },
    },
  })

  var numSlides = swiper.slides.length

  if (numSlides == 2) {
    swiper.$el.addClass('two-slides')
  }
  if (numSlides == 1) {
    swiper.$el.addClass('one-slide')
  }
}

export default Events
